import { useState, useEffect, useRef } from 'react';
import './enter-code.css';

const EnterCode = ({...props}) => {
    const {len, onFinish} = props;
    const [code, setCode] = useState(Array.from({ len }, () => ''));
    const inputRef = useRef(null);

    // Фокус на скрытом инпуте для обработки ввода с клавиатуры
    useEffect(() => inputRef.current.focus(), [inputRef]);

    const handleChange = (e) => {
        const { value } = e.target;
        // Оставить только цифры и ограничить длину
        const digits = value.replace(/\D/g, '').slice(0, len); 
        if (digits.length <= len) setCode(digits.split(''));
        // Процедура проверки кода
        if (digits.length === len) onFinish(digits);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Backspace') {
            setCode((prev) => {
                const newCode = [...prev];
                const lastEmptyIndex = newCode.lastIndexOf(''); // Находим последний пустой индекс
                if (lastEmptyIndex !== -1) {
                    newCode[lastEmptyIndex - 1] = ''; // Удаляем цифру до последней пустой
                } else if (prev[len - 1]) {
                    newCode[len - 1] = ''; // Если нет пустых, очищаем последний символ
                }
                return newCode;
            });
        }
    };

    return (
        <div>
            <div className='ener-code-row'>
                {
                  Array.from({ length: len }, (_, index) => index)
                    .map(i => 
                        <div key={i} onClick={() => inputRef.current.focus()} className='enter-code-char'>
                        {i < code.length ? code[i] : null}
                      </div>
                    )
                }
            </div>
            <input type="text"
                maxLength={len}
                ref={inputRef}
                style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
            />
        </div>
    );

}

export default EnterCode;